<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" :class="{ 'shifted': isLoggedIn }" href="/">
        <img src="@/assets/hobibaca-horizon.png" alt="HobiBaca Logo" class="header-logo" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link">Beranda</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/langganan" class="nav-link">Langganan</router-link>
          </li>
          
          <!-- Dropdown Menu for Categories (Fixed Alignment) -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="categoryDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Kategori
            </a>
            <div class="dropdown-menu dropdown-menu-end dropdown-large" aria-labelledby="categoryDropdown">
              <div class="row">
                <!-- Fiction Column -->
                <div class="col-md-6">
                  <h6 class="dropdown-header">Fiksi</h6>
                  <ul class="category-list">
                    <li v-for="category in fictionCategories.filter(cat => cat.parent === null)" :key="category.id">
                      <router-link :to="`/categories/${category.id}`" class="dropdown-item">
                        {{ category.name }}
                      </router-link>
                      <ul v-if="category.subcategories.length" class="dropdown-submenu">
                        <li v-for="sub in category.subcategories" :key="sub.id">
                          <router-link :to="`/categories/${sub.id}`" class="dropdown-item">
                            ─ {{ sub.name }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <!-- Non-Fiction Column -->
                <div class="col-md-6">
                  <h6 class="dropdown-header">Non-Fiksi</h6>
                  <ul class="category-list">
                    <li v-for="category in nonFictionCategories.filter(cat => cat.parent === null)" :key="category.id">
                      <router-link :to="`/categories/${category.id}`" class="dropdown-item">
                        {{ category.name }}
                      </router-link>
                      <ul v-if="category.subcategories.length" class="dropdown-submenu">
                        <li v-for="sub in category.subcategories" :key="sub.id">
                          <router-link :to="`/categories/${sub.id}`" class="dropdown-item">
                            ─ {{ sub.name }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item" v-if="isLoggedIn">
            <router-link to="/notifications" class="nav-link">
              <span class="notification-badge">
              <font-awesome-icon :icon="['fas', 'bell']" />
              </span>
            </router-link>
          </li>
          <!-- Not logged in: Show Register and Login links -->
          <li class="nav-item" v-if="!isLoggedIn">
            <router-link to="/register" class="nav-link">Daftar</router-link>
          </li>
          <li class="nav-item" v-if="!isLoggedIn">
            <router-link to="/login" class="nav-link btn-login">Login</router-link>
          </li>
          
          <!-- Logged in: Show user dropdown with avatar and logout -->
          <li class="nav-item dropdown" v-if="isLoggedIn">
            <a class="nav-link dropdown-toggle user-menu" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown">
              <img v-if="avatar" :src="avatar" alt="Avatar" class="user-avatar" />
              <span v-else class="user-avatar-placeholder">
                <font-awesome-icon :icon="['fas', 'user']" />
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link to="/profile" class="dropdown-item">
                <font-awesome-icon :icon="['fas', 'user']" class="dropdown-icon" />
                Profil
              </router-link>
              <router-link to="/subscription" class="dropdown-item">
                <font-awesome-icon :icon="['fas', 'crown']" class="dropdown-icon" />
                Langganan
              </router-link>
              <router-link to="/notifications" class="dropdown-item">
                <font-awesome-icon :icon="['fas', 'book-open']" class="dropdown-icon" />
                Pemberitahuan
              </router-link>
              <div class="dropdown-divider"></div>
              <a @click="logout" class="dropdown-item">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="dropdown-icon" />
                Logout
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import { Dropdown } from "bootstrap";
import { eventBus } from '@/eventBus';

export default {
  name: "Navbar",
  data() {
    return {
      fictionCategories: [],
      nonFictionCategories: [],
      username: '',
      role: '',
      avatar: '',
      isLoggedIn: false
    };
  },
  created() {
    // Set initial auth state
    this.updateAuthState();
    
    // Listen for auth events
    eventBus.on('login-success', this.updateAuthState);
    eventBus.on('logout-success', this.updateAuthState);
    eventBus.on('register-success', this.updateAuthState);
  },
  beforeUnmount() {
    // Clean up event listeners
    eventBus.off('login-success', this.updateAuthState);
    eventBus.off('logout-success', this.updateAuthState);
    eventBus.off('register-success', this.updateAuthState);
  },
  methods: {
    updateAuthState() {
      const token = localStorage.getItem('token');
      this.isLoggedIn = !!token;
      
      if (this.isLoggedIn) {
        this.username = localStorage.getItem('username') || 'User';
        this.role = localStorage.getItem('role') || '';
        this.avatar = localStorage.getItem('avatar') || '';
      } else {
        this.username = '';
        this.role = '';
        this.avatar = '';
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('avatar');
      
      this.updateAuthState();
      eventBus.emit('logout-success');
      
      // Redirect to home page
      this.$router.push('/');
    },
    async fetchCategories() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/book-categories/`);
        const categories = response.data;

        this.fictionCategories = categories.filter(cat => cat.category_type === "fiction");
        this.nonFictionCategories = categories.filter(cat => cat.category_type === "non-fiction");

        this.$nextTick(() => {
          const dropdownElement = document.getElementById("categoryDropdown");
          if (dropdownElement) {
            new Dropdown(dropdownElement);
          }
        });
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    }
  },
  async mounted() {
    await this.fetchCategories();
  }
};
</script>

<style scoped>
.header-logo {
  height: 40px;
}

.navbar-brand.shifted {
  margin-left: 250px; /* Sesuaikan dengan lebar sidebar */
  transition: margin-left 0.3s ease;
}

/* Responsif untuk layar mobile */
@media (max-width: 768px) {
  .navbar-brand.shifted {
    margin-left: 0;
  }
}

/* General Dropdown Styling */
.dropdown-large {
  width: 500px;
  padding: 15px;
}

.dropdown-header {
  font-weight: bold;
  font-size: 16px;
  padding-left: 10px;
}

.category-list {
  list-style: none;
  padding-left: 10px;
}

.dropdown-submenu {
  padding-left: 15px;
  list-style: none;
}

.dropdown-item {
  text-decoration: none;
  display: block;
  padding: 5px 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

/* Ensure dropdown does not overflow on the right */
.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
  max-width: 90vw;
  overflow-x: auto;
}

/* User menu styling */
.user-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-avatar-placeholder {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.username-text {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Login button styling */
.btn-login {
  font-weight: 500;
}

/* Dropdown icons */
.dropdown-icon {
  width: 20px;
  margin-right: 8px;
  color: #6c757d;
}

/* Dropdown divider */
.dropdown-divider {
  margin: 5px 0;
  border-top: 1px solid #e9ecef;
}
</style>